import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { Checkbox } from 'common-components'
import FormEngine from 'e-submission/components/FormEngine'
import styled from 'styled-components'
import { FormFeedback } from 'reactstrap'
import { ECBR_PAYER_TYPE } from 'e-submission/domain/data-model/constants'
import {
  setAppValue,
  unsetAppValue,
  setHideEcbrSystemizationFailedModal,
  pretendPayingQrCode,
} from 'e-submission/apps/actions'
import { PayerSection, getRelationshipInfoMessage } from './PayerSection'
import PayerInfoApiFailedModal from 'e-submission/containers/Dialog/PayerInfoApiFailedModal'
import { getToggles } from 'quick-quote/feature-toggles'
import {
  getPolicyId,
  getQRRef2,
  getTotalFirstPremiumNetBankPayment,
} from 'e-submission/domain/data-model/form/selectors'
import { getAppConfig } from 'deploy-env/app-config'

const Header = styled.label`
  font-weight: bold;
`
let Container = styled.div`
  margin-top: 20px;
`

if (getToggles().ENABLE_QR_PAYMENT_STATUS) {
  Container = styled.div`
    margin-top: 0;
  `
}

const InformationQrContainer = styled.div`
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
`
const InformationQrContainerLabel = styled.div`
  width: 25%;
`

const InformationQrContainerData = styled.div`
  width: 75%;
  text-align: right;
`

const FieldGroup = styled.div`
  input,
  .text {
    text-align: left !important;
    max-width: 100% !important;
    font-size: 1rem !important;
  }
  margin-top: -20px !important;
  ${({ theme }) => theme.media.sm`
  margin: 0 -50px;
  `};
`
const Content = styled.div`
  margin-top: 0.75rem;
  margin-bottom: 1rem;
`

const payerTypeText = {
  insured: 'ผู้เอาประกัน',
  payer: 'ผู้ชำระเบี้ย',
  other: 'บุคคลอื่น',
}

const PayerInfo = (props) => {
  const { isSendLink } = props

  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const currentApp = useSelector((state) => getCurrentApp(state))
  let detailOfPayment = null
  const [clickedPayerType, setClickedPayerType] = useState(null)

  const app = useSelector((state) => getCurrentApp(state))

  const payerType = _.get(app, 'payerInfo.payerType', 'insured')
  const isPayer = _.get(app, 'insured.isPayer')
  const isOpenEcbrSystemizationModal = _.get(state, `ui.isEcbrSystemizationModal`)
  const policyId = getPolicyId(app)
  const ref2 = getQRRef2(app)
  const totalFirstPremiumNetBankPayment = getTotalFirstPremiumNetBankPayment(app)

  useEffect(() => {
    setClickedPayerType(payerType)
  }, [payerType])

  const closeEcbrSystemizationFailedModal = () => dispatch(setHideEcbrSystemizationFailedModal())
  const pretendPayingQrCode = () => dispatch(pretendPayingQrCode())

  if (getToggles().ENABLE_QR_PAYMENT_STATUS && totalFirstPremiumNetBankPayment) {
    detailOfPayment = (
      <InformationQrContainer>
        <div className="row">
          <InformationQrContainerLabel>Biller ID:</InformationQrContainerLabel>
          <InformationQrContainerData>0107555000376</InformationQrContainerData>
        </div>
        <div className="row">
          <InformationQrContainerLabel>Suffix:</InformationQrContainerLabel>
          <InformationQrContainerData>01</InformationQrContainerData>
        </div>
        <div className="row">
          <InformationQrContainerLabel>Ref 1:</InformationQrContainerLabel>
          <InformationQrContainerData>{policyId}</InformationQrContainerData>
        </div>
        <div className="row">
          <InformationQrContainerLabel>Ref 2:</InformationQrContainerLabel>
          <InformationQrContainerData>{ref2}</InformationQrContainerData>
        </div>
      </InformationQrContainer>
    )
  }

  const handleInputChange = (key, value) => {
    if (value === ECBR_PAYER_TYPE.INSURED || value === ECBR_PAYER_TYPE.PAYER) {
      dispatch(unsetAppValue(`payerInfo.firstName`))
      dispatch(unsetAppValue(`payerInfo.lastName`))
      dispatch(unsetAppValue(`payerInfo.idType`))
      dispatch(unsetAppValue(`payerInfo.idNo`))
      dispatch(unsetAppValue(`payerInfo.relations`))
    }
    dispatch(setAppValue(`payerInfo.${key}`, value))
    setClickedPayerType(value)
  }

  return (
    <>
      {detailOfPayment}
      <div data-testid="ecbr-section" style={{ marginTop: '20px' }}>
        <Container>
          <Header>กรุณาเลือกผู้ชำระเบี้ยประกัน (เจ้าของบัญชีที่ใช้ในการชำระเบี้ย)</Header>
        </Container>
        {isSendLink ? (
          <>
            <Content>{payerTypeText[clickedPayerType]}</Content>
            {clickedPayerType === ECBR_PAYER_TYPE.OTHER && (
              <FormFeedback className="info-message attached-icon">{getRelationshipInfoMessage()}</FormFeedback>
            )}
            <div>{getToggles().OC_ENVIRONMENT}</div>
          </>
        ) : (
          <>
            <Container>
              <Checkbox
                id={ECBR_PAYER_TYPE.INSURED}
                checked={clickedPayerType === ECBR_PAYER_TYPE.INSURED}
                onChange={() => handleInputChange('payerType', ECBR_PAYER_TYPE.INSURED)}
              >
                ผู้เอาประกัน
              </Checkbox>
              <Checkbox
                id={ECBR_PAYER_TYPE.PAYER}
                disabled={isPayer}
                checked={clickedPayerType === ECBR_PAYER_TYPE.PAYER}
                onChange={() => handleInputChange('payerType', ECBR_PAYER_TYPE.PAYER)}
              >
                ผู้ชำระเบี้ย
              </Checkbox>
              <Checkbox
                id={ECBR_PAYER_TYPE.OTHER}
                checked={clickedPayerType === ECBR_PAYER_TYPE.OTHER}
                onChange={() => handleInputChange('payerType', ECBR_PAYER_TYPE.OTHER)}
              >
                บุคคลอื่น (โปรดระบุ ชื่อนามสกุล หมายเลขบัตรประชาชน และความสัมพันธ์)
              </Checkbox>
            </Container>
            {clickedPayerType === ECBR_PAYER_TYPE.OTHER && (
              <FieldGroup>
                <FormEngine sections={[PayerSection('payerInfo')(app)]} />
              </FieldGroup>
            )}
            {getAppConfig().OC_ENVIRONMENT === 'dev' && Boolean(totalFirstPremiumNetBankPayment) && (
              <div style={{ 'text-align': 'center' }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    pretendPayingQrCode()
                  }}
                >
                  <span>Pretend paying of QR code</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
      {getToggles().ENABLE_ECBR_SYSTEMIZATION && (
        <PayerInfoApiFailedModal closeModal={closeEcbrSystemizationFailedModal} isOpen={isOpenEcbrSystemizationModal} />
      )}
    </>
  )
}

export default PayerInfo
